import { Menu } from "antd/es";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common/common-props";
import { Icon, IconLibrary, IconType } from "../icon/icon";

interface SubMenuProps {
  children?: ReactNode;
  icon?: string;
  iconLibrary?: IconLibrary;
  iconType?: IconType;
}

interface SubMenuState {}

class SubMenu extends PureComponent<SubMenuProps & CommonProps, SubMenuState> {
  constructor(props: SubMenuProps) {
    super(props);
    this.state = {};
  }

  getProps = () => {
    const props: any = _.clone(this.props);
    if (props.icon) {
      // Both Material and Font Awesome glyphs size from the submenu's own
      // style.fontSize. When it's absent the size stays undefined so the icon
      // falls back to antd's menu icon slot sizing (like the legacy `<span
      // class="material-icons md-24">`) — a hardcoded size would render an
      // oversized glyph.
      props.icon = (
        <Icon
          iconName={props.icon}
          iconLibrary={props.iconLibrary}
          iconType={props.iconType}
          style={{ fontSize: props.style?.fontSize }}
        />
      );
    }
    if (props.iconLibrary) {
      delete props.iconLibrary;
    }
    if (props.iconType) {
      delete props.iconType;
    }
    if (props.label) {
      props.title = props.label;
    }
    if (props.link) {
      props.children = (
        <a href={props.link} target="_self">
          {props.label}
        </a>
      );
    }
    props.key = props.key ?? props.id ?? Guid.create().toString();
    delete props.children;
    return props;
  };

  render(): ReactNode {
    return <Menu.SubMenu {...this.getProps()}>{this.props.children}</Menu.SubMenu>;
  }
}

const subMenu = withCommonEvents(SubMenu);
export { subMenu as SubMenu };
